// Module
var code = "<div class=\"ali-danmu-input\">\n  <input type=\"text\" placeholder=\"\">\n  <button class=\"danmu-input-enter\"></button>\n</div>";
// Exports
module.exports = code;